import React from 'react'
import Form from '../component/register/Form'
export default function Register() {
  return (
    <div  className='container  myRegister'  >
      <Form />
    </div>
  )
}
